module.exports = __webpack_public_path__ + "static/characteristics-upgrade-96839127bc17a52f7c620d74598d6694.png";